import React from 'react';
import { Button, notification } from 'antd';
import { NetworkLayer } from '../../../services/common';

const commonService = new NetworkLayer();

const DownloadButton = ({ jobId, notificationKey }) => (
  <Button
    type="primary"
    size="small"
    onClick={async (e) => {
      e.stopPropagation();
      try {
        const response = await commonService.amlsDownloadUrlAPI(jobId);
        if (response?.downloadUrl) {
          window.open(response.downloadUrl, '_blank');
        }
      } catch (err) {
        console.error('Failed to fetch download URL:', err);
      }
      notification.close(notificationKey);
    }}>
    Download
  </Button>
);

export const showExportReadyNotification = (response, options = {}) => {
  const notificationKey = `export-ready-${response.jobId}`;
  const { onNavigate } = options;

  const handleNotificationClick = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  notification.success({
    key: notificationKey,
    message: 'Export Ready',
    description:
      response?.message ||
      'This export has already been generated and is ready for download.',
    btn: (
      <DownloadButton
        jobId={response.jobId}
        notificationKey={notificationKey}
      />
    ),
    duration: 0,
    onClick: handleNotificationClick,
    style: onNavigate ? { cursor: 'pointer' } : {}
  });
};
